import React from 'react';
import { useTranslation } from '../../../../i18n';
import { getBonusIntro } from '../../../../i18n/helpers';

export interface PuzzleHostProps {
  /** Image URL to show (full puzzle). Empty while loading. */
  imageUrl: string;
}

/**
 * Host view for Quick Puzzle bonus game.
 * Shows the full puzzle image so players can match it on their devices.
 * All puzzle host UI lives here; BonusLevelHost only delegates.
 */
export const PuzzleHost: React.FC<PuzzleHostProps> = ({ imageUrl }) => {
  const { t } = useTranslation();
  const title = getBonusIntro('puzzle').title;

  return (
    <div style={{ textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
      <h2 className="bonus-game-playing-title" style={{ marginBottom: '1rem', color: 'var(--color-primary)' }}>
        {title}
      </h2>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 1.5rem 1.5rem' }}>
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={t('gameplay.imageAlt.puzzleMatch')}
            style={{ maxWidth: '100%', maxHeight: 320, objectFit: 'contain', borderRadius: 12 }}
          />
        ) : (
          <div className="bonus-host-glow-text--muted" style={{ fontSize: '1rem', minHeight: 200 }}>{t('bonus.host.loadingPuzzle')}</div>
        )}
      </div>
    </div>
  );
};
